export const PRICE_TYPES = {
  TOTAL: "TOTAL",
  PER_NIGHT: "PER_NIGHT",
};
